import Link from 'next/link'
import dynamic from 'next/dynamic'

const UserDropdown = dynamic(
  async () =>
    await import('../Header/UserDropdown').then(mod => mod.UserDropdown),
  { ssr: false }
)

interface SlimHeaderProps {
  title: string
}

export function SlimHeader(props: SlimHeaderProps) {
  return (
    <header className="min-w-full bg-white flex justify-between p-4 shadow-sm">
      <div className="container flex items-center mx-auto justify-between">
        <span className="flex items-center">
          <Link href="/">
            <a>
              <img
                src="/logo/icon.png"
                width="auto"
                height={34}
                className="block pr-4 w-16 border-r border-gray-200"
              />
            </a>
          </Link>
          <h1 className="block pl-4 font-black text-lg text-gray-800 leading-none">
            {props.title ?? 'Majordomo'}
          </h1>
        </span>
        <UserDropdown />
      </div>
    </header>
  )
}
